import React from 'react'
import IconlyIconContainer from '../../../Components/Icons/IconlyIcon'

export default function IconlyIcon() {
    return (
        <div className='page-body'>
            <IconlyIconContainer />
        </div>
    )
}